import '../i18n';

import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Button, Col, Modal, Row, Spinner } from 'react-bootstrap';
import DatePicker from 'react-date-picker';
import { withTranslation } from 'react-i18next';

import { addBooking } from '../actions/bookings';
import { getMyMooring } from '../actions/moorings';
import FormCheckbox from '../components/FormCheckbox';
import globalStyles from '../stylesheets/globalStyles';
import { getTextAreaHeight } from '../utils/utilities';
import CancelButton from './CancelButton';
import FormInput from './FormInput';
import StatusAlerts from './StatusAlerts';

const i18nPrefix = 'AddBookingModal';

class AddBookingModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      create: false, //Are we creating or editing a boat
      loading: false,
      success: false,
      error: false,
      from_date: moment(),
      to_date: moment(),
      notes: '',
      internal_paid: false,
    };
  }

  componentDidMount() {
    this.props.onRef && this.props.onRef(this);
  }

  show = (mooring_id, from_date, to_date) => {
    console.log('from, to', from_date, to_date);

    // normalize to moment objects and enforce minimum to_date = from_date + 1 day
    let f = moment(from_date);
    let t = to_date ? moment(to_date) : moment(f).add(1, 'day');

    // If swapped (t before f), swap them back
    if (t.isBefore(f, 'day')) {
      const tmp = f;
      f = t;
      t = tmp;
    }

    // Ensure minimum: to_date must be at least from_date + 1 day
    if (!t.isAfter(f, 'day')) {
      t = moment(f).add(1, 'day');
    }

    if (f) {
      this.setState({
        show: true,
        mooring_id: mooring_id,
        from_date: f,
        to_date: t,
        notes: '',
      });
    }
    getMyMooring(
      mooring_id,
      (mooring) => {
        this.setState({ mooring: mooring });
      },
      () => {},
    );
  };

  handleShow = () => {
    this.setState({ show: true });
  };

  handleClose = () => {
    this.props.onClose && this.props.onClose();
    this.setState({ show: false });
  };

  handleBookClick = () => {
    this.setState({ success: false, loading: true, error: false }, () => {
      const booking = {
        mooring: false,
        mooring_id: this.state.mooring_id,
        from_date: this.state.from_date,
        to_date: this.state.to_date,
        notes: this.state.notes,
        internal_paid: this.state.internal_paid,
        numberOfAdults: '0',
        numberOfChildren: '0',
        payment_method: 'internal',
      };
      addBooking(
        booking,
        () => {
          this.setState({ loading: false, success: true }, () => {
            this.props.onBookingSuccessful && this.props.onBookingSuccessful();
            this.handleClose();
          });
        },
        (error) => {
          this.setState({ loading: false, error: true });
          const errorMessage = this.props.t(
            `errors.${error.response.data.language_variable}`,
          );
          this.setState({ errorMessage: errorMessage });
        },
      );
    });
  };

  render() {
    const { t } = this.props;

    const element = document.getElementById('FormInputNotes');
    if (element) {
      var s_height = element.scrollHeight;
      element.setAttribute('style', 'height:' + s_height + 'px');
    }

    return (
      <Modal
        id='modal_add_booking'
        show={this.state.show}
        onHide={this.handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{t(`${i18nPrefix}.title`)}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {this.state.mooring && (
            <FormInput
              id='input_reservation_name'
              label={t(`${i18nPrefix}.berth_number`)}
              placeholder={t(`${i18nPrefix}.notesPlaceholder`)}
              value={`${this.state.mooring.harbour_name} ${this.state.mooring.berth_number}`}
              // onChange={(event) => { this.setState({ notes: event.target.value }) }}
            />
          )}

          <Row>
            <Col>
              <FormInput
                id={'input_from_date'}
                label={t(`global.from`)}
                type='date'
                required
                value={moment(this.state.from_date).format('YYYY-MM-DD')}
                onChange={(e) => {
                  const date = moment(e.target.value);
                  // Ensure to_date is at least from_date + 1 day
                  let toDate = this.state.to_date
                    ? moment(this.state.to_date)
                    : moment(date).add(1, 'day');
                  if (!toDate.isAfter(date, 'day')) {
                    toDate = moment(date).add(1, 'day');
                  }
                  this.setState({ from_date: date, to_date: toDate });
                }}
              />
            </Col>
            <Col>
              <FormInput
                id={'input_to_date'}
                label={t(`global.to`)}
                type='date'
                required
                // set HTML min attribute so browser prevents invalid selection
                min={moment(this.state.from_date)
                  .add(1, 'day')
                  .format('YYYY-MM-DD')}
                value={moment(this.state.to_date).format('YYYY-MM-DD')}
                onChange={(e) => {
                  const date = moment(e.target.value);
                  const min = moment(this.state.from_date).add(1, 'day');
                  // if selected date is before the minimum, enforce minimum
                  if (date.isBefore(min, 'day')) {
                    this.setState({ to_date: min });
                  } else {
                    this.setState({ to_date: date });
                  }
                }}
              />
            </Col>
          </Row>

          {/* internal_paid */}
          <FormCheckbox
            id={'checkbox_internal_paid'}
            label={t(`${i18nPrefix}.internal_paid`)}
            checked={this.state.internal_paid}
            onChange={(e) => {
              this.setState({
                internal_paid: e.target.checked,
              });
            }}
          />

          <FormInput
            id={'input_notes'}
            as='textarea'
            label={t(`${i18nPrefix}.notes`)}
            placeholder={t(`${i18nPrefix}.notesPlaceholder`)}
            value={this.state.notes}
            rows={getTextAreaHeight(this.state.notes)}
            onChange={(event) => {
              this.setState({ notes: event.target.value });
            }}
            last
          />

          <Button
            id={'button_book'}
            style={{ ...globalStyles.normalButton, width: '100%' }}
            onClick={() => this.handleBookClick()}>
            {t(`${i18nPrefix}.bookMooring`)}
            {this.state.loading && (
              <Spinner
                style={{ width: 20, height: 20, marginLeft: 10 }}
                animation='border'
                variant='secondary'
                role='status'
              />
            )}
          </Button>
          <StatusAlerts
            state={this.state}
            errorMessage={this.state.errorMessage}
          />
        </Modal.Body>
      </Modal>
    );
  }
}

export default withTranslation()(AddBookingModal);
